import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-odd.svg";
import * as styles from "./Icon.module.scss";

type IconOddProps = React.SVGProps<SVGSVGElement>;

export const IconOdd = ({ className, ...props }: IconOddProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
